import { TFunction } from 'i18next';
import { ToastOptions } from 'modules/toast/hooks/useToast';
import { ExtractionErrorOnboardingRedirectButton } from 'shared/components/ExtractionErrorOnboardingRedirectButton';
import { ExtractionSuccessOnboardingRedirectButton } from 'shared/components/ExtractionSuccessOnboardingRedirectButton';

export const extractionInProgressToastId = 'extractionInProgressToast';
export const extractionInProgress = (t: TFunction): ToastOptions => ({
  toastId: extractionInProgressToastId,
  closeable: false,
  loading: true,
  title: t('toast:extraction.inProgress.title'),
  message: <>{t('toast:extraction.inProgress.message')}</>,
});

export const extractionSuccessToastId = 'extractionSuccessToast';
export const extractionSuccess = (t: TFunction): ToastOptions => ({
  toastId: extractionSuccessToastId,
  icon: 'check',
  autoClose: 120000,
  title: t('toast:extraction.success.title'),
  message: (
    <>
      <span>{t('toast:extraction.success.messagePart1')}</span>
      <ExtractionSuccessOnboardingRedirectButton
        variant="text"
        className="!inline-block"
        label={t('common:here')}
      />
      <span>{t('toast:extraction.success.messagePart2')}</span>
    </>
  ),
});

export const extractionErrorToastId = 'extractionErrorToast';
export const extractionError = (t: TFunction): ToastOptions => ({
  toastId: extractionErrorToastId,
  color: 'warning',
  title: t('toast:extraction.error.title'),
  icon: 'info',
  autoClose: 120000,
  message: (
    <>
      <span>{t('toast:extraction.error.messagePart1')}</span>
      <ExtractionErrorOnboardingRedirectButton
        variant="text"
        className="!inline-block"
        label={t('common:here')}
      />
      <span>{t('toast:extraction.error.messagePart2')}</span>
    </>
  ),
});

export const profileVerifiedToastId = 'profileVerifiedToastId';
export const profileVerified = (t: TFunction): ToastOptions => ({
  toastId: profileVerifiedToastId,
  color: 'success',
  title: t('toast:profile.verified.title'),
  icon: 'check',
  autoClose: 120000,
  message: <>{t('toast:profile.verified.message')}</>,
});

export const allToastIds = [
  extractionInProgressToastId,
  extractionSuccessToastId,
  extractionErrorToastId,
  profileVerifiedToastId,
];
